export { computeStackTrace } from './computeStackTrace';
export { report, subscribe, unsubscribe } from './report';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/@datadog/browser-core/esm/domain/tracekit/index.js
// module id = ../../../../@datadog/browser-core/esm/domain/tracekit/index.js
// module chunks = 5